//import { type } from 'os';
import { BaseEntity } from '../models';

export function sortBy<T>(key: keyof T, a: T, b: T): number {
  if (a[key] < b[key]) {
    return -1;
  } else if (a[key] > b[key]) {
    return 1;
  } else {
    return 0;
  }
}

export function sortArrayBy<T>(array: T[], key: keyof T): T[] {
  return Array.isArray(array) ? array.sort((a, b) => sortBy<T>(key, a, b)) : [];
}

export function sortArrayById<T extends BaseEntity>(array: T[]): T[] {
  return Array.isArray(array) ? array.sort((a, b) => (typeof a.id === 'string' ? parseInt(a.id) : a.id) >= (typeof b.id === 'string' ? parseInt(b.id) : b.id) ? 1 : -1) : array;
}
